import React from "react";
import PropTypes from 'prop-types';

import './Video.scss';

const Video = ({ src, caption, controls, autoPlay, muted, loop, playsInline }) => {
  return (
    <div className="video">
      <video className="video__media" controls={controls} autoPlay={autoPlay} playsInline={autoPlay || playsInline} muted={autoPlay ? true : muted} loop={loop}>
        <source src={src} type="video/mp4" />
      </video>
      <If condition={caption}>
        <figcaption className="caption monospace video__caption">{caption}</figcaption>
      </If>
    </div>
  );
}

Video.propTypes = {
  src: PropTypes.string,
  caption: PropTypes.string,
  controls: PropTypes.bool,
  autoPlay: PropTypes.bool,
  muted: PropTypes.bool,
  loop: PropTypes.bool,
  playsInline: PropTypes.bool
}

export default Video;
